import { supabase } from '../lib/supabase';

export const qrService = {
  getOrCreateQr: async (cardId, userId) => {
    const { data: existing, error: findError } = await supabase
      .from('card_qr_codes')
      .select('*')
      .eq('card_id', cardId)
      .is('event_id', null)
      .single();

    if (existing) return existing;
    if (findError && findError.code !== 'PGRST116') throw findError;

    const token = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 6);
    
    const { data: newQr, error: insertError } = await supabase
      .from('card_qr_codes')
      .insert({ card_id: cardId, user_id: userId, token: token })
      .select()
      .single();

    if (insertError) throw insertError;
    return newQr;
  },

  createEventQr: async (eventId, cardId, label, userId) => {
    const token = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 6);
    const { data, error } = await supabase
      .from('card_qr_codes')
      .insert({
        card_id: cardId,
        event_id: eventId,
        user_id: userId,
        token: token,
        label: label
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  getEventQrs: async (eventId) => {
    const { data, error } = await supabase
      .from('card_qr_codes')
      .select('*, cards(internal_name)')
      .eq('event_id', eventId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  resolveToken: async (token) => {
    const { data, error } = await supabase.rpc('resolve_qr_token', { p_token: token });
    if (error) throw error;
    return data && data.length > 0 ? data[0].slug : null;
  }
};